import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

/* Put all uiSchema options here, in the template they go under ui:options: */
export const EntityNameValidatorUiOptionsSchema = z.object({
  debounceMs: z.number().optional().describe('Debounce delay in milliseconds'),
  isEditMode: z
    .boolean()
    .optional()
    .describe('Whether the field is in edit mode'),
  type: z.string().optional().describe('Type of entity to validate'),
  typeDisplayName: z
    .string()
    .optional()
    .describe('Display name of entity type to validate'),
});

// Transforms the Zod schema to a TypeScript type
export type EntityNameValidatorUiOptions = z.infer<
  typeof EntityNameValidatorUiOptionsSchema
>;

/* The field schema for the EntityNameValidator field extension */
export const EntityNameValidatorFieldSchema = makeFieldSchemaFromZod(
  z.string().describe('Entity Name Validator'),
  EntityNameValidatorUiOptionsSchema,
);

// Transforms the field schema props to a TypeScript type
export type EntityNameValidatorProps =
  typeof EntityNameValidatorFieldSchema.type;

/* The final custom field extension schema used for the field extension */
export const EntityNameValidatorSchemaFinal =
  EntityNameValidatorFieldSchema.schema;

// Legacy export for backward compatibility (if needed)
export const EntityNameValidatorSchema = EntityNameValidatorFieldSchema.schema;
